import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown-container position-relative col" }
const _hoisted_2 = { class: "dropdown-input dropdown bg-primary-white w-100 outline-none caption d-flex align-items-center" }

import { useStore } from "vuex"

// Components
import Participants from "@/vue/planning/components/search/participants.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'flightParticipants',
  setup(__props) {

const store = useStore()

const handleChangeOpenParticipants = (bool: boolean) => {
	store.dispatch("setParticipantsDropdownOpen", bool)
}

const handleSetParticipants = (newArray: Array<unknown>) => {
	store.dispatch("setParticipants", newArray)
}

const handleNotEnoughAdults = () => {
	store.commit("setErrorMessageOpen", "errorMessages_notEnoughAdults")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Participants, {
        onChangeOpenParticipants: handleChangeOpenParticipants,
        onSetParticipants: handleSetParticipants,
        onNotEnoughAdults: handleNotEnoughAdults
      })
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "label",
      style: {"z-index":"1"}
    }, _toDisplayString("Guests"), -1))
  ]))
}
}

})